<template>
  <div></div>
</template>

<script>
import 'codemirror/lib/codemirror.css';
import 'codemirror/theme/rubyblue.css';

const CodeMirror = require('codemirror/lib/codemirror.js');
require('codemirror/mode/javascript/javascript.js');

export default {
  name: 'TextEditor',
  components: { },
  props: {
    text: {
      type: String,
      required: true,
    },
    lineNumbers: {
      type: Boolean,
      default: true,
    },
  },
  watch: {
    text() {
      this.editor.setValue(this.text);
    },
  },
  mounted() {
    this.editor = CodeMirror(this.$el, this.options);
    this.editor.setValue(this.text);
    const vm = this;
    this.editor.on('change', (cm) => {
      vm.code = cm.getValue();
      vm.$emit('update:text', vm.code);
    });
  },
  data() {
    return {
      options: {
        mode: 'javascript',
        lineNumbers: this.lineNumbers,
        lineWrapping: true,
        matchBrackets: true,
        autoCloseBrackets: true,
        theme: 'rubyblue',
        viewportMargin: Infinity,
        readOnly: false,
      },
      code: '',
    };
  },
  methods: {
    onCmCodeChange(newCode) {
      this.code = newCode;
    },
  },
};
</script>

<style lang="scss">
@import '@/scss/colors.scss';

.CodeMirror {
  height: 100%;
}
</style>
